(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7744],{

/***/ 20940:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/liked/products",
      function () {
        return __webpack_require__(9735);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ LikedProductsPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22120);
/* harmony import */ var hooks_useRedux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34349);
/* harmony import */ var redux_slices_currency__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64698);
/* harmony import */ var services_like__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20290);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29969);
/* harmony import */ var containers_liked_liked__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99947);
/* harmony import */ var services_product__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32837);
/* harmony import */ var components_seo__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84169);
/* harmony import */ var hooks_useDebounce__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48606);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67294);
/* harmony import */ var containers_settings_settings__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(93298);














function LikedProductsPage() {
    var ref;
    const { i18n  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    const { isAuthenticated  } = (0,contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_7__/* .useAuth */ .a)();
    const currency = (0,hooks_useRedux__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .C)(redux_slices_currency__WEBPACK_IMPORTED_MODULE_4__/* .selectCurrency */ .j);
    const { productList  } = (0,hooks_useRedux__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .C)((state)=>state.liked);
    const lang = i18n.language;
    const debouncedProductList = (0,hooks_useDebounce__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(productList, 500);
    const { data: serverLikedProducts , isLoading: isServerLikedProductsLoading , isFetching: isServerLikedProductsFetching , hasNextPage , fetchNextPage  } = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery)({
        queryKey: [
            "likedProducts",
            lang,
            currency === null || currency === void 0 ? void 0 : currency.id,
            query === null || query === void 0 ? void 0 : query.shop_id
        ],
        queryFn: (param)=>{
            let { pageParam =1  } = param;
            return services_like__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getAll */ .Z.getAll({
                type: "product",
                perPage: 12,
                page: pageParam,
                currency_id: currency === null || currency === void 0 ? void 0 : currency.id,
                shop_id: (query === null || query === void 0 ? void 0 : query.shop_id) || undefined
            });
        },
        getNextPageParam: (lastPage)=>{
            var ref, ref1;
            if ((lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.meta) === null || ref === void 0 ? void 0 : ref.current_page) < (lastPage === null || lastPage === void 0 ? void 0 : (ref1 = lastPage.meta) === null || ref1 === void 0 ? void 0 : ref1.last_page)) {
                var ref2;
                return (lastPage === null || lastPage === void 0 ? void 0 : (ref2 = lastPage.meta) === null || ref2 === void 0 ? void 0 : ref2.current_page) + 1;
            }
        },
        enabled: isAuthenticated,
        staleTime: 0
    });
    const { data: localLikedProducts , isLoading: isLocalLikedProductsLoading  } = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)({
        queryKey: [
            "likedUnAuthProducts",
            lang,
            currency === null || currency === void 0 ? void 0 : currency.id,
            debouncedProductList
        ],
        queryFn: ()=>{
            const params = {
                currency_id: currency === null || currency === void 0 ? void 0 : currency.id,
                shop_id: (query === null || query === void 0 ? void 0 : query.shop_id) || undefined,
                perPage: 100,
                ...debouncedProductList.reduce((acc, curr, index)=>({
                        ...acc,
                        ["products[".concat(index, "]")]: curr.productId
                    }), {})
            };
            return services_product__WEBPACK_IMPORTED_MODULE_9__/* ["default"].getByIds */ .Z.getByIds(params);
        },
        enabled: !isAuthenticated && !!debouncedProductList.length,
        keepPreviousData: true,
        staleTime: 0
    });
    const extractedServerLikedProducts = serverLikedProducts === null || serverLikedProducts === void 0 ? void 0 : (ref = serverLikedProducts.pages) === null || ref === void 0 ? void 0 : ref.flatMap((page)=>{
        return (page === null || page === void 0 ? void 0 : page.data) || [];
    });
    const actualList = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(()=>{
        if (isAuthenticated) {
            return extractedServerLikedProducts || [];
        }
        if (productList.length) {
            return (localLikedProducts === null || localLikedProducts === void 0 ? void 0 : localLikedProducts.data) || [];
        }
        return [];
    }, [
        isAuthenticated,
        extractedServerLikedProducts,
        localLikedProducts,
        productList
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_seo__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(containers_settings_settings__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(containers_liked_liked__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    type: "product",
                    data: actualList,
                    isLoading: isAuthenticated ? isServerLikedProductsLoading && isServerLikedProductsFetching : isLocalLikedProductsLoading,
                    hasNextPage: hasNextPage,
                    isFetchingNextPage: isServerLikedProductsFetching,
                    fetchingNextPage: fetchNextPage
                })
            })
        ]
    });
}


/***/ }),

/***/ 32837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25728);
// services/product.ts

const productService = {
    // liste
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/paginate", {
            params
        }),
    getAllShopProducts: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/".concat(id, "/products"), {
            params
        }),
    search: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/search", {
            params
        }),
    getViewed: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/product-histories/paginate", {
            params
        }),
    // singolo prodotto
    // UUID (legacy): /rest/products/:uuid
    getById: (uuid, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/".concat(uuid), {
            params
        }),
    // **NUMERICO**: /rest/products/id/:id  --> quello che useremo nella pagina
    getByIdNumber: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/id/".concat(id), {
            params
        }),
    // bulk per ids (rimane com’è)
    getByIds: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/ids", {
            params
        }),
    // alias temporaneo (deprecato)
    getByIdLegacyUuid: (uuid, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/".concat(uuid), {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (productService);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8300,6594,9774,2888,179], function() { return __webpack_exec__(20940); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);